import React from "react"
import { Panel, Container, CheckBoxField, Label, TextField, Toolbar, Button, FieldSet, ComboBoxField, Image, DatePickerField, NumberField } from "@sencha/ext-modern"
import GroupCheckBox from 'tyan/components/GroupCheckBox'
import GroupRadioField from "tyan/components/GroupRadioField"
import { connect } from 'react-redux'
import { compose } from 'redux'
import Message from 'tyan/components/Message'
import { doGetInspectionInfo, doSaveInspectionInfo, doSubmitInspectionInfo, doDelInspectionDeviceInfo } from 'tyan/reducers/actions'
import { WX, getUrl } from 'tyan/public'
import { showFile, getFileIcon } from 'tyan/public/index'
import Dialog from 'tyan/components/Dialog'
import 'tyan/css/DetalApproval.css';
import TreeListView from 'tyan/components/TreeListView'
import { nullDate, equalFuns, reconfigButton } from 'tyan/public/utility'
Ext.require('Ext.MessageBox')
const style = {
  outer: {
    backgroundColor: "#f5f5f5",
    padding: "10px",
  },
  innerContainer: {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    padding: "10px",
    width: "100%",
  },
  titleContainer: {
    borderBottom: "1px solid #f5f5f5",
  },
}
class DataEntryInfo extends React.Component {
  state = {
    inspectionInfo: null,
    errorMessage: null,
    saving: false,
    changeValues: null,
    contractMessage: null,
    showDialog: false,
  }

  componentDidMount = () => {
    const { doGetInspectionInfo, match: { params: { sampleInspectionID } } } = this.props
    doGetInspectionInfo({
      sampleInspectionID,
      onEnd: ({ inspectionInfo, errorMessage }) => {
        this.setState({ inspectionInfo, errorMessage })
      }
    })

  }

  getFullName = ({ item, namePrefix }) => ((namePrefix && (namePrefix + '_') || '') + (item.name || item.title))

  isEqual = (value1, value2) => (JSON.stringify(Array.isArray(value1) && value1.sort() || value1) === JSON.stringify(Array.isArray(value2) && value2.sort() || value2))

  handleBack = () => {
    const { history, match: { params: { source } } } = this.props
    Ext.toast(`执行成功！`)
    history.goBack()
  }

  handleSubmit = (sampleInspectionID, action, comment, needInstrument) => {
    const { doSubmitInspectionInfo } = this.props
    const { changeValues, inspectionInfo } = this.state
    if (changeValues == null) {
      if (inspectionInfo && inspectionInfo.基本信息) {
        for (var i = 0; i < inspectionInfo.基本信息.length; i++) {
          let item = inspectionInfo.基本信息[i]
          if (item.name == '实际开始时间' && (item.value == null || item.value == '' || item.value == '1900-01-01' || item.value == 0)) {
            return Ext.Msg.show({
              title: "错误", message: "开始时间不能为空"
            })
          }
          if (item.name == '实际结束时间' && (item.value == null || item.value == '' || item.value == '1900-01-01' || item.value == 0)) {
            return Ext.Msg.show({
              title: "错误", message: "结束时间不能为空"
            })
          }
          if (item.name == '试验照片' && inspectionInfo.isPhoto == '是' && (item.value == null || item.value == '' || item.value == '[]')) {
            return Ext.Msg.show({
              title: "错误", message: "请上传照片"
            })
          }
        }
      }
    }
    else {
      if (changeValues.实际开始时间 == 0) {
        return Ext.Msg.show({
          title: "错误", message: "开始时间不能为空"
        })
      }
      if (changeValues.实际结束时间 == 0) {
        return Ext.Msg.show({
          title: "错误", message: "结束时间不能为空"
        })
      }
      if (inspectionInfo.isPhoto == '是' && changeValues.试验照片 == null || changeValues.试验照片 == '' || changeValues.试验照片 == '[]') {
        return Ext.Msg.show({
          title: "错误", message: "请上传照片"
        })
      }
    }

    doSubmitInspectionInfo({
      sampleInspectionID: inspectionInfo.sampleInspectionID,
      action,
      comment,
      changeValues,
      needInstrument,
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          if (errorMessage == '未填写设备信息，请确认。') {
            return Ext.Msg.show({
              title: "警告", message: errorMessage,
              buttons: [{ itemId: "ok", text: "忽略问题继续" }, { itemId: "cancel", text: "取消" }],
              fn: (buttonID) => buttonID == "ok" && this.handleSubmit(inspectionInfo.sampleInspectionID, '检测中.提交校核', '', '')
            })
          }
          else {
            return Ext.Msg.show({
              title: "错误", message: errorMessage
            })
          }
        } else {
          this.handleBack()
        }
      }
    })
  }

  handleSave = (sampleInspectionID) => {
    const { doSaveInspectionInfo } = this.props
    const { changeValues, inspectionInfo } = this.state
    // console.log('inspectionInfo', inspectionInfo)
    console.log('changeValues', changeValues)
    if (changeValues == null) {
      if (inspectionInfo && inspectionInfo.基本信息) {
        for (var i = 0; i < inspectionInfo.基本信息.length; i++) {
          let item = inspectionInfo.基本信息[i]
          if (item.name == '实际开始时间' && (item.value == null || item.value == '' || item.value == '1900-01-01' || item.value == 0)) {
            return Ext.Msg.show({
              title: "错误", message: "开始时间不能为空"
            })
          }
          if (item.name == '实际结束时间' && (item.value == null || item.value == '' || item.value == '1900-01-01' || item.value == 0)) {
            return Ext.Msg.show({
              title: "错误", message: "结束时间不能为空"
            })
          }
        }
      }
    }
    else {
      if (changeValues.实际开始时间 == 0) {
        return Ext.Msg.show({
          title: "错误", message: "开始时间不能为空"
        })
      }
      if (changeValues.实际结束时间 == 0) {
        return Ext.Msg.show({
          title: "错误", message: "结束时间不能为空"
        })
      }
    }

    doSaveInspectionInfo({
      sampleInspectionID,
      changeValues,
      onRequest: () => this.setState({ saving: true }),
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          this.setState({ errorMessage, saving: false })
        } else {
          this.props.history.goBack()
        }
      }
    })
  }

  //文本控件
  inputRender = ({ item, level, changeValues }) => {
    return <TextField key={item.name}
      labelAlign="left"
      labelWidth="auto"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      // name={item.name}
      value={changeValues[item.name]}
      width="100%"
      onChange={(obj, value) => this.handlerInputChange({ name: item.name, value })}
    />
  }
  handlerInputChange = ({ name, value }) => {
    const changeValues = this.getChangeValues()
    if (!this.isEqual(value, changeValues[name])) {
      let changeValuesNew = { ...changeValues, [name]: value }
      this.setState({ changeValues: changeValuesNew })
    }
  }
  //日期控件
  dateRender = ({ item, level, changeValues }) => {
    const d = item.value && item.value !== nullDate && new Date(changeValues[item.name]) || null
    let value = d && new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes())
    console.log('value', value)
    return <DatePickerField key={item.name}
      style={style.titleContainer}
      labelAlign="left"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black' font-size='14px'>" + item.name + "：</font>" || null}
      labelWidth="auto"
      // name={item.name}
      value={value}
      width="100%"
      dateFormat="Y/m/d H:i"
      onChange={(obj, value) => this.handlerDateChange({ name: item.name, value })} />
  }
  handlerDateChange = ({ name, value }) => {
    if (name == '实际开始时间' && value.getHours() == 0 && value.getMinutes() == 0) {
      value.setHours(value.getHours() + 8)
      value.setMinutes(value.getMinutes() + 30)
    }
    if (name == '实际结束时间' && value.getHours() == 0 && value.getMinutes() == 0) {
      value.setHours(value.getHours() + 17)
      value.setMinutes(value.getMinutes() + 30)
    }
    console.log('value1', value)
    const changeValues = this.getChangeValues()
    // const newValue = value && Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes()).valueOf()
    var d = new Date(value).valueOf()
    if (!this.isEqual(d, changeValues[name])) {
      let changeValuesNew = { ...changeValues, [name]: d }
      this.setState({ changeValues: changeValuesNew })
    }
  }

  //复选控件
  checkboxRender = ({ item, level }) => {
    return <GroupCheckBox key={item.name}
      margin={"0 0 0 " + (level * 28)}
      label={item.name + "：" || null}
      options={item.options}
      onCheck={obj => {
        const checked = obj.getChecked()
        const option = obj.getBoxLabel()
        const value = item.value && [...item.value] || []
        const index = value.indexOf(option)
        checked && index === -1 && value.push(option)
        !checked && index >= 0 && value.splice(index, 1)
        this.handlerInputChange({ name: item.name, value })
      }}
      checked={item.value}
    />
  }

  //单选控件
  radioRender = ({ item, level, }) => {
    return <GroupRadioField key={item.name}
      margin={"0 0 0 " + (level * 28)}
      label={item.name + "：" || null}
      options={item.options}
      onCheck={obj => this.handlerInputChange({ name: item.name, value: obj.getBoxLabel() })}
      // name={item.name}
      checked={item.value}
      width="100%"
    />
  }
  //下拉控件
  dropdownlistRender = ({ item, level }) => {
    return <ComboBoxField key={item.name}
      labelAlign="left"
      labelWidth="auto"
      margin={"0 0 0 " + (level * 28)}
      label={"<font color='black'>" + item.name + "：</font>" || null}
      options={item.options}
      onChange={(obj, value) => this.handlerInputChange({ name: item.name, value })}
      // name={item.name}
      value={item.value}
      width="100%"
    />
  }

  //数字控件
  numberRender = ({ item, level }) => {
    return <NumberField key={item.name}
      labelAlign="left"
      label={"<font color='black'>" + item.name + "：</font>" || null}
      labelWidth="auto"
      // name={item.name}
      value={item.value}
      width="100%"
      onChange={(obj, value) => this.handlerInputChange({ name: item.name, value })}
    />
  }

  //拍照控件
  photoRender = ({ item, level, changeValues }) => {
    // console.log('changeValues', changeValues);
    return (<FieldSet key={item.name} title={item.name} labelWidth="auto" width="100%">
      <Container layout={{ type: 'vbox', pack: 'start' }} key={item.name} style={style.innerContainer} padding="0">
        {changeValues[item.name] && changeValues[item.name].map((photo, index) => (
          <Container key={'c_' + index} layout={{ type: 'hbox', align: "start", pack: "space-between" }} >
            <Button key={item.name + '_' + index} ui="confirm round" text={photo.photoName ? photo.photoName : '照片' + (index + 1)} textAlign="left" handler={() => this.setState({ showDialog: true, path: photo.file })} />
            <Container key={'c1_' + index} layout={{ type: 'hbox', align: "start", pack: "space-between", align: 'right' }} >
              <Button margin={"0 0 0 " + (level * 28)} ui="" text="重命名" margin="0 0 0 0" handler={() =>
                Ext.Msg.show({
                  title: "重命名", message: "",
                  value: photo.photoName ? photo.photoName : '照片' + (index + 1),
                  prompt: true,
                  buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
                  fn: (buttonID, value) => buttonID == "ok" && this.handleRename(changeValues, item.name, index, photo.file, photo.path, photo.serverId, value)
                })
              } />
              <Button margin={"0 0 0 " + (level * 28)} ui="" text="删除" margin="0 0 0 0" handler={() =>
                Ext.Msg.show({
                  title: "警告", message: "确定要删除吗？",
                  buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
                  fn: buttonID => buttonID == "ok" && this.handleDeleteImage(changeValues, item.name, index)
                })
              } />
            </Container>
          </Container>
        ))}
      </Container>
      <Container layout={{ type: 'vbox', align: 'right' }}>
        <Button margin={"0 0 0 " + (level * 28)} ui="" text="拍照" margin="0 10 0 0" handler={() => this.handleChooseImage(changeValues, item.name)} />
      </Container>
    </FieldSet>
    )
  }

  handleChooseImage = (changeValues, name) => {
    this.setState({ changeValues: changeValues })
    WX.chooseImage({
      count: 9,
      onChoosed: ({ file, serverId }) => {
        const { changeValues } = this.state
        !changeValues && (changeValues = {})
        !changeValues[name] && (changeValues[name] = [])
        const changeValuesNew = { ...changeValues, [name]: [...changeValues[name], { file: file, serverId: serverId }] }
        this.setState({ changeValues: changeValuesNew })
      }
    })
  }


  handleDeleteImage = (changeValues, name, index) => {
    changeValues[name].splice(index, 1)
    const changeValuesNew = { ...changeValues, [name]: [...changeValues[name]] }
    this.setState({ changeValues: changeValuesNew })
  }

  handleRename = (changeValues, name, index, file, path, serverId, value) => {
    if (typeof (serverId) == "undefined") {
      changeValues[name][index] = { file: file, serverId: serverId, photoName: value }
    }
    else {
      changeValues[name][index] = { file: file, path: path, serverId: serverId, photoName: value }
    }
    const changeValuesNew = { ...changeValues, [name]: [...changeValues[name]] }
    // console.log('changeValuesNew', changeValuesNew);
    this.setState({ changeValues: changeValuesNew })
  }

  imageDialog = () => {
    const { path, showDialog } = this.state
    return (
      <Dialog
        displayed={showDialog}
        title="图片查看"
        maximizable
        bodyPadding="20"
        maxWidth="200"
        scrollable
        style='max-height: calc(100vh - 210px); overflow-y: auto;'
        defaultFocus="#ok"
        html=''
      >
        <Image mode="" src={getUrl(path)} width="100%" height="auto" scrollable />
        <Button text={'关闭'} handler={() => this.setState({ showDialog: false })} />
      </Dialog>
    )
  }

  //设备
  instrumentRender = ({ item, level }) => {
    return (<FieldSet key={item.name} title={item.name} labelWidth="auto" width="100%">
      <Container layout={{ type: 'vbox', pack: 'start' }} key={item.name} style={style.innerContainer} padding="0">
        {item.value && item.value.map((o, index) => (
          <Container key={'c_' + index} layout={{ type: 'hbox', align: "start", pack: "space-between" }} >
            <Label cls="label" key={item.name + '_' + index} html={o.inspectionDevice} padding="0 0 0 0" width='60%' />
            <Container key={'c_' + index} layout={{ type: 'hbox', align: "start", pack: "space-between", align: 'right' }} width='40%'>
              <Button margin={"0 0 0 " + (level * 28)} ui="" text="修改" margin="0 0 0 0" handler={() => this.handleUpdateInspectionDeviceInfo(o.inspectionDeviceID)} />
              <Button margin={"0 0 0 " + (level * 28)} ui="" text="删除" margin="0 0 0 0" handler={() =>
                Ext.Msg.show({
                  title: "警告", message: "确定要删除吗？",
                  buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
                  fn: buttonID => buttonID == "ok" && this.handleDelInspectionDeviceInfo(o.inspectionDeviceID)
                })} />
            </Container>
          </Container>
        ))}
      </Container>
      <Container layout={{ type: 'vbox', align: 'right' }}>
        <Button margin={"0 0 0 " + (level * 28)} ui="" text="添加" margin="0 10 0 0" handler={() => this.handleUpdateInspectionDeviceInfo(-1)} />
      </Container>
    </FieldSet>
    )
  }

  handleUpdateInspectionDeviceInfo = (inspectionDeviceID) => {
    const { doSaveInspectionInfo } = this.props
    const { inspectionInfo, changeValues } = this.state
    doSaveInspectionInfo({
      sampleInspectionID: inspectionInfo.sampleInspectionID,
      changeValues,
      onRequest: () => this.setState({ saving: true }),
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          this.setState({ errorMessage, saving: false })
        } else {
          location.hash = `/QYWX/InspectionDeviceInfo/${inspectionInfo.sampleInspectionID}/${inspectionDeviceID}`
        }
      }
    })
  }

  handleDelInspectionDeviceInfo = (inspectionDeviceID) => {
    const { doDelInspectionDeviceInfo } = this.props
    const { inspectionInfo } = this.state
    doDelInspectionDeviceInfo({
      sampleInspectionID: inspectionInfo.sampleInspectionID,
      inspectionDeviceID: inspectionDeviceID,
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          this.setState({ errorMessage })
        } else {
          this.componentDidMount()
          // this.handleBack()
        }
      }
    })
  }

  loadBaseInfo = (inspectionInfo, changeValues) => {
    return (
      <Container layout={{ type: "vbox", align: "left" }} style={style.innerContainer} padding="0" >
        {inspectionInfo && inspectionInfo.基本信息.map((item, index) => {
          switch (item.type) {
            case "attachment":
              return (
                <Container key={index} layout={{ type: 'hbox', pack: 'start' }}>
                  <Label cls="label" key={index} html={item.name + '：'} padding="12 0 12 0" />
                  <Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + item.ext)} cls="file-button" text="详情..." height="80%" handler={() => showFile({ path: item.path, ext: item.ext })} />
                </ Container>)
            case "tree":
              return (
                <TreeListView key={item.name} data={item.children} />)
            case "logs":
              return (
                <Container layout={{ type: 'vbox', pack: 'start' }} key={index}>
                  <Label cls="label" key={index} html={item.name + '：'} />
                  {item.list && item.list.map((o, i) => (
                    <Label style={style.titleContainer} cls="label" key={i} html={o.content} padding="8 0 0 0" />
                  ))}
                </Container>
              )
            case "attachmentList":
              return (
                <Container layout={{ type: 'hbox', pack: 'start' }} key={index}>
                  <Label cls="label" key={index} html={item.name + '：'} />
                  <Container layout={{ type: 'vbox', pack: 'start', }} padding="0 0 0 10" >
                    {item.list && item.list.map((o, i) => (
                      <Container key={i} layout={{ type: 'vbox', pack: 'start', }} width="100%" padding="0 0 0 0" >
                        <Button ui="confirm round" iconCls={"x-fa fa-file-" + getFileIcon('.' + o.ext)} cls="file-button" text={o.file} height="80%" handler={() => showFile({ path: o.path, ext: o.ext })} />
                      </ Container>
                    )
                    )}
                  </ Container>
                </Container>
              )
            case "input":
              return (this.inputRender({ item: item, level: 0, changeValues }))
            case "date":
              return (this.dateRender({ item: item, level: 0, changeValues }))
            case "checkbox":
              return (this.checkboxRender({ item: item, level: 0 }))
            case "radio":
              return (this.radioRender({ item: item, level: 0 }))
            case "dropdownlist":
              return (this.dropdownlistRender({ item: item, level: 0 }))
            case "number":
              return (this.numberRender({ item: item, level: 0 }))
            case "photo":
              return (this.photoRender({ item: item, level: 0, changeValues }))
            case "instrument":
              return (this.instrumentRender({ item: item, level: 0 }))
            default:
              return (<Label cls="label" key={index} html={item.name + '：' + item.value} padding="0 0 0 0" style={item.name == '项目名称' ? { backgroundColor: 'yellow' } : {}} />)
          }
        })}
      </ Container>
    )
  }



  loadInspectionInfo = (inspectionInfo, changeValues) => {
    return (
      <Container layout={{ type: "vbox", align: "left" }} style={style.innerContainer} padding="0" width="100%">
        <Container key={'c_部件数'} layout={{ type: 'hbox', align: "start", pack: "space-between" }} width="100%">
          <Label cls="label" key={'部件数'} html={'部件数：' + changeValues["部件数"]} padding="0 0 0 0" />
          <Container key={'c_部件数'} layout={{ type: 'hbox', align: "start", pack: "space-between" }}>
            <Button margin={"0 0 10 0"} ui="" text="增加" margin="0 0 10 0" handler={() => this.handleChoosenumberOfParts("增加", changeValues)} />
            <Button margin={"0 0 10 0"} ui="" text="减少" margin="0 0 10 0" handler={() => this.handleChoosenumberOfParts("减少", changeValues)} />
          </Container>
        </Container>
        {inspectionInfo && inspectionInfo.项目信息.map((item) => {
          return (
            <Container layout={{ type: 'vbox', pack: 'start' }} key={'c_' + item.contractGuidelineID} padding="0 0 0 0" width="100%">
              <Container layout={{ type: 'vbox', pack: 'start' }} key={'c_检测项目_' + item.contractGuidelineID} padding="0 0 0 0" width="100%">
                <Label cls="label" key={'检测项目_' + item.contractGuidelineID} html={'检测项目：' + item.检测项目} padding="0 0 0 0" style={{ backgroundColor: 'yellow' }} />
              </Container>
              <Container layout={{ type: 'vbox', pack: 'start' }} key={'c_单位_' + item.contractGuidelineID} padding="0 0 0 0" width="100%">
                <TextField key={'单位_' + item.contractGuidelineID}
                  labelAlign="left"
                  labelWidth="auto"
                  margin={"0 0 0 0"}
                  label={"<font color='black'>单位：</font>" || null}
                  // name={'单位'}
                  value={changeValues['单位_' + item.contractGuidelineID]}
                  width="100%"
                  onChange={(obj, value) => this.handlerInputChange({ name: '单位_' + item.contractGuidelineID, value })}
                />
              </Container>
              <Container layout={{ type: 'vbox', pack: 'start' }} key={'c_要求_' + item.contractGuidelineID} padding="0 0 0 0" width="100%">
                <Label cls="label" key={'要求_' + item.contractGuidelineID} html={'要求：' + item.要求} padding="0 0 0 0" />
              </Container>
              {changeValues.部件信息.map((o, index) => {
                return (
                  <Container layout={{ type: 'vbox', pack: 'start' }} key={'c_部件信息_' + item.contractGuidelineID + '_' + (index + 1)} padding="0 0 0 0" width="100%">
                    {o.实物样品.map((m) => {
                      return (
                        <Container layout={{ type: 'vbox', pack: 'start' }} key={'c_value_' + item.contractGuidelineID + '_' + (index + 1) + '_' + m.specimenID} padding="0 0 0 0" width="100%">
                          <TextField key={'value_' + item.contractGuidelineID + '_' + (index + 1) + '_' + m.specimenID}
                            labelAlign="left"
                            labelWidth="auto"
                            margin={"0 0 0 0"}
                            label={"<font color='black'>" + (changeValues["部件数"] > 1 ? m.number + "-" + (index + 1) : m.number) + "</font>" || null}
                            // name={(changeValues["部件数"] > 1 ? m.number + "-" + (index + 1) : m.number)}
                            value={changeValues['value_' + item.contractGuidelineID + '_' + (index + 1) + '_' + m.specimenID]}
                            width="100%"
                            onChange={(obj, value) => this.handlerInputChange({ name: 'value_' + item.contractGuidelineID + '_' + (index + 1) + '_' + m.specimenID, value })}
                          />
                        </Container>
                      )
                    })}
                    <Container layout={{ type: 'vbox', pack: 'start' }} key={'c_备注_' + item.contractGuidelineID + '_' + (index + 1)} padding="0 0 0 0" width="100%">
                      <TextField key={'备注_' + item.contractGuidelineID + '_' + (index + 1)}
                        labelAlign="left"
                        labelWidth="auto"
                        margin={"0 0 0 0"}
                        label={"<font color='black'>备注：</font>" || null}
                        // name={'备注'}
                        value={changeValues['备注_' + item.contractGuidelineID + '_' + (index + 1)]}
                        width="100%"
                        onChange={(obj, value) => this.handlerInputChange({ name: '备注_' + item.contractGuidelineID + '_' + (index + 1), value })}
                      />
                    </Container>
                  </Container>
                )
              })}

              <Container layout={{ type: 'vbox', pack: 'start' }} key={'c_单项判定_' + item.contractGuidelineID} padding="0 0 0 0" width="100%">
                <ComboBoxField key={'单项判定_' + item.contractGuidelineID}
                  labelAlign="left"
                  labelWidth="auto"
                  margin={"0 0 0 0"}
                  label={"<font color='black'>单项判定：</font>" || null}
                  // name={'单项判定'}
                  value={changeValues['单项判定_' + item.contractGuidelineID]}
                  width="100%"
                  options={item.单项判定选项}
                  onChange={(obj, value) => this.handlerInputChange({ name: '单项判定_' + item.contractGuidelineID, value })}
                />
              </Container>

            </Container>
          )
        })
        }
      </ Container >
    )
  }

  handleChoosenumberOfParts = (type, changeValues) => {
    let { inspectionInfo } = this.state
    let changeValuesOld = changeValues['部件数']
    if (type == '减少') {
      changeValues['部件数'] = changeValues['部件数'] - 1
      changeValues.部件信息.splice(changeValues['部件数'], 1)
      inspectionInfo && inspectionInfo.项目信息.map((item) => {
        delete changeValues['备注_' + item.contractGuidelineID + '_' + changeValuesOld]
        item.实物样品信息.map((o) => {
          delete changeValues['value_' + item.contractGuidelineID + '_' + changeValuesOld + '_' + o.specimenID]
        })
      })
    }
    if (type == '增加') {
      changeValues['部件数'] = changeValues['部件数'] + 1
      inspectionInfo && inspectionInfo.项目信息.map((item, index) => {
        changeValues['备注_' + item.contractGuidelineID + '_' + changeValues['部件数']] = ""
        if (index == 0) {
          changeValues.部件信息.push({
            实物样品: item.实物样品信息.map((o) => (
              {
                specimenID: o.specimenID,
                number: o.number,
                value: "",
              }
            )), 备注: ''
          })
        }
        item.实物样品信息.map((o) => {
          changeValues['value_' + item.contractGuidelineID + '_' + changeValues['部件数'] + '_' + o.specimenID] = ""
        })
      })
    }
    this.setState({ changeValues: changeValues })
  }

  getChangeValues = () => {
    const { inspectionInfo, changeValues } = this.state
    if (!changeValues) {
      let changeValuesOld = {}
      inspectionInfo && inspectionInfo.基本信息.map((item) => {
        changeValuesOld[item.name] = item.value
      })
      if (inspectionInfo) {
        changeValuesOld['部件数'] = inspectionInfo.numberOfParts
      }
      inspectionInfo && inspectionInfo.项目信息.map((item) => {
        changeValuesOld['单位_' + item.contractGuidelineID] = item.单位
        changeValuesOld['单项判定_' + item.contractGuidelineID] = item.单项判定
        changeValuesOld['部件信息'] = item.部件信息
        item.部件信息.map((o, index) => {
          changeValuesOld['备注_' + item.contractGuidelineID + '_' + (index + 1)] = o.备注
          o.实物样品.map((m) => {
            changeValuesOld['value_' + item.contractGuidelineID + '_' + (index + 1) + '_' + m.specimenID] = m.value
          })
        })
      })
      return { ...changeValuesOld }
    }
    return { ...changeValues }
  }

  render() {
    const { inspectionInfo, errorMessage, saving } = this.state
    if (errorMessage) {
      return <Message text="错误" subtext={errorMessage} />
    } else if (!inspectionInfo) {
      return <Message text="数据加载中..." />
    }

    const changeValues = this.getChangeValues()
    const panelProps = {
      height: "100%",
      margin: "0 0 0 0",
      padding: "0 0 0 0",
    }

    return (
      <Panel shadow layout="vbox" {...panelProps}>
        <Container layout="vbox" flex={4} scrollable style={style.outer}>
          {this.loadBaseInfo(inspectionInfo, changeValues)}
          {this.loadInspectionInfo(inspectionInfo, changeValues)}
        </Container>
        <Toolbar shadow={false} docked="bottom" layout={{ type: 'hbox', pack: 'right' }}>
          <Button ui="action raised" text="提交校核" margin="0 10 0 0" handler={() => {
            Ext.Msg.show({
              title: "警告", message: "确定要提交吗？",
              buttons: [{ itemId: "ok", text: "确定" }, { itemId: "cancel", text: "取消" }],
              fn: (buttonID) => buttonID == "ok" && this.handleSubmit(inspectionInfo.sampleInspectionID, '检测中.提交校核', '', '需要')
            })
          }} />
          <Button ui="action raised" text="保存" margin="0 10 0 0" handler={() => this.handleSave(inspectionInfo.sampleInspectionID)} disabled={saving} />
        </Toolbar>
        {this.imageDialog()}
      </Panel>
    )
  }
}

const mapStateToProps = ({ }) => ({})

export default compose(
  connect(mapStateToProps, { doGetInspectionInfo, doSaveInspectionInfo, doSubmitInspectionInfo, doDelInspectionDeviceInfo }),
)(DataEntryInfo)
